
import React from 'react';
import { UserCircle, Users } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { UserRole } from '@/types';
import { useLanguage } from '@/context/language-context';

interface RoleSelectorProps {
  selectedRole: UserRole;
  onRoleChange: (role: string) => void;
  idPrefix?: string;
}

export const RoleSelector: React.FC<RoleSelectorProps> = ({ 
  selectedRole, 
  onRoleChange,
  idPrefix = ""
}) => {
  const { t } = useLanguage();
  
  return (
    <div className="space-y-1">
      <Label>{t('Account type')}</Label>
      <RadioGroup 
        defaultValue={selectedRole} 
        className="grid grid-cols-2 gap-4 pt-2"
        onValueChange={onRoleChange}
      >
        <div className={`flex flex-col items-center justify-between rounded-md border-2 p-4 cursor-pointer ${selectedRole === 'client' ? 'border-primary' : 'border-muted hover:border-primary/50'}`}>
          <RadioGroupItem value="client" id={`${idPrefix}client`} className="sr-only" />
          <Label htmlFor={`${idPrefix}client`} className="cursor-pointer flex flex-col items-center gap-2">
            <UserCircle className="h-6 w-6 mb-1" />
            <span>{t('Client')}</span>
          </Label>
        </div>
        
        <div className={`flex flex-col items-center justify-between rounded-md border-2 p-4 cursor-pointer ${selectedRole === 'escort' ? 'border-primary' : 'border-muted hover:border-primary/50'}`}>
          <RadioGroupItem value="escort" id={`${idPrefix}escort`} className="sr-only" />
          <Label htmlFor={`${idPrefix}escort`} className="cursor-pointer flex flex-col items-center gap-2">
            <Users className="h-6 w-6 mb-1" />
            <span>{t('Escort')}</span>
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
